import { useNavigate } from 'react-router-dom';
import { UserForm } from '../features/users/UserForm';
import { useCreateUser } from '../features/users/api';
import type { CreateUserInput } from '@app/shared';
import { getApiErrorMessage } from '../lib/api-client';

export function UserNewPage(): JSX.Element {
  const navigate = useNavigate();
  const mutation = useCreateUser();

  return (
    <section>
      <header className="mb-4">
        <h1 className="text-2xl font-semibold">新增使用者</h1>
      </header>
      {mutation.isError ? (
        <div role="alert" className="mb-3 text-red-600">
          建立失敗：{getApiErrorMessage(mutation.error, '未知錯誤')}
        </div>
      ) : null}
      <UserForm
        mode="create"
        submitting={mutation.isPending}
        onSubmit={(values) => {
          mutation.mutate(values as CreateUserInput, {
            // 建完回上一頁而不是跳 /settings/users 頂層(REQ-20260820006),
            // 與編輯頁同一條收尾
            onSuccess: () => navigate(-1),
          });
        }}
      />
    </section>
  );
}
